// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Of77","inner":"Footer_inner__1BoSz","nextIcon":"Footer_nextIcon__HOckm","innerLeft":"Footer_innerLeft__1RT1_"};